export default function Hero404() {
  const navigateTo = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  return (
    <section className="relative flex flex-col items-center justify-center text-center px-4 pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden bg-soft-gray">
      {/* Filigrane 404 */}
      <span className="absolute inset-0 flex items-center justify-center text-[10rem] md:text-[18rem] font-black text-slate-primary/[0.04] select-none pointer-events-none">
        404
      </span>

      <div className="relative z-10 max-w-2xl">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-urgent/10">
          <i className="ri-error-warning-line text-4xl text-urgent" />
        </div>
        <h1 className="text-[40px] md:text-5xl font-bold text-slate-primary mb-4">
          Oups, cette page n&apos;existe pas
        </h1>
        <p className="text-lg md:text-xl text-slate-primary/70 mb-8 max-w-xl mx-auto">
          Mais pas de stress, on va vous remettre sur la bonne route !
        </p>
        <button
          onClick={() => navigateTo('/')}
          className="inline-flex items-center gap-2 bg-copper hover:bg-copper-dark text-white font-semibold px-8 py-3 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line" />
          Retour à l&apos;accueil
        </button>
      </div>
    </section>
  );
}